import { Application, ApplicationStatusHistory } from 'models/application'
import { PaginationParams, PaginationResponse } from 'models/pagination'
import { IStatistic } from 'models/statistic'

import { clientApi } from './clientApi'

export type ApplicationParams = {
  status: string
  region_id: string
  start_date: string
  end_date: string
  consultant: string
  region: string
  branch: string
  limit?: number
  pan: string
  inn: string
  fio: string
  supervisor?: string
  use_verification_date: boolean
  p_islamic?: boolean
  m_junior?: boolean
  el_kart?: boolean
  master_card?: boolean
  messi_master_card?: boolean
  messi_m_junior?: boolean
  card_group?: 'junior' | 'standard'
}

export interface ApplicationReworkDTO {
  controller_comment: string
}

export const ApplicationApi = {
  getApplications(params: PaginationParams) {
    return clientApi.get<PaginationResponse<Application>>(
      '/web/applications/',
      {
        params,
      },
    )
  },
  getApplicationsStatistics(params: PaginationParams) {
    return clientApi.get<IStatistic[]>('/web/applications/statistics/', {
      params,
    })
  },
  getApplicationsByReports(params: PaginationParams) {
    return clientApi.get<PaginationResponse<Application>>(
      '/web/applications/by_region/',
      {
        params,
      },
    )
  },
  getApplicationById(id: number) {
    return clientApi.get(`/web/applications/${id}/`)
  },
  getApplicationStatusHistoryById(id: number) {
    return clientApi.get<ApplicationStatusHistory[]>(
      `/web/applications/${id}/status-history/`,
    )
  },
  approveApplication(id: number) {
    return clientApi.put(`/web/applications/${id}/approve/`)
  },
  refuseApplication(id: number) {
    return clientApi.put(`/web/applications/${id}/refuse/`)
  },
  reworkApplication(id: number, body: ApplicationReworkDTO) {
    return clientApi.put(`/web/applications/${id}/rework/`, body)
  },
  generateExcel(params: Partial<ApplicationParams>) {
    return clientApi.get('/web/applications/excel/', {
      params,
    })
  },
  downloadApplicationsBonus(params: Partial<ApplicationParams>) {
    return clientApi.get('/web/applications/bonus_excel/', {
      responseType: 'blob',
      params,
    })
  },
  downloadApplicationsForMonth(params: Partial<ApplicationParams>) {
    return clientApi.get('/web/applications/excel_for_month/', {
      responseType: 'blob',
      params,
    })
  },
}
